<template>
	<BaseButton
		tag="router-link"
		to="/messages"
		variant="tertiary"
		size="sm"
		icon-only
		class="relative"
		:aria-label="label"
	>
		<Icon
			:name="Icons.Bell"
			class="w-8 text-evergreen-800"
		/>
		<span
			v-if="unreadCount > 0"
			class="unread-count"
		>
			{{ badgeCount }}
		</span>
	</BaseButton>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

const MAX_BADGE_COUNT = 9

export default defineComponent({
	computed: {
		unreadCount(): number {
			return this.$store.state.secureMessages.unreadCount
		},
		badgeCount(): string {
			return this.unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(this.unreadCount)
		},
		label(): string {
			return this.$tc('unread messages', this.unreadCount, { count: this.unreadCount })
		},
	},
})
</script>
<style scoped lang="scss">
.unread-count {
	@apply absolute flex items-center justify-center rounded-full bg-error-500 text-white text-body-xs font-bold;
	top: -2px;
	right: -2px;
	min-width: 18px;
	height: 18px;
	padding: 0 4px;
	line-height: 1;
}
</style>
